module.exports = __webpack_public_path__ + "static/perigoso-substantivos-f52d9e51503484ae84e777dcb8b76461.jpg";